import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-arcade-guide-viewer',
  templateUrl: './arcade-guide-viewer.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ArcadeGuideViewerComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private sanitizer = inject(DomSanitizer);

  safeUrl: SafeResourceUrl | null = null;
  guideName = '';

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const url = params['url'];
      this.guideName = params['name'] || 'Interactive Guide';
      if (url) {
        this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
      }
    });
  }

  goBack(): void {
    this.router.navigate(['/interactive-guide']);
  }
}
